module.exports = __webpack_public_path__ + "static/media/user-pic.f6b87e91.svg";